import "../css/hero.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../config/config";

function HeroBanner() {

    const navigate = useNavigate();

    const [banner, setBanner] = useState(null);

    useEffect(() => {

        axios

        .get(`${API_URL}/hero-banner`)

        .then((res) => {

            setBanner(res.data);

        })

        .catch(console.log);

    }, []);

    if (!banner) return null;

    return (

        <section

            className="hero"

            style={{
                backgroundImage:
                    `url(http://localhost:5000${banner.image})`
            }}

        >

            <div className="overlay">

                <span className="hero-tag">

                    🥃 PREMIUM LIQUOR STORE

                </span>

                <h1>

                    {banner.title}

                </h1>

                <p>

                    {banner.subtitle}

                </p>

                <div className="hero-buttons">

                    <button

                        className="shop-btn"

                        onClick={() => navigate(banner.button_link)}

                    >

                        {banner.button_text}

                    </button>

                </div>

                <div className="hero-features">

                    <div>🚚 Free Shipping</div>

                    <div>⭐ Premium Brands</div>

                    <div>💳 Secure Checkout</div>

                    <div>🥃 1000+ Products</div>

                </div>

            </div>

        </section>

    );

}

export default HeroBanner;